var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-10",staticStyle:{"max-width":"600px"}},[(_vm.isLoading)?_c('please-wait',{staticClass:"mt-3"}):_c('large-post-card',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }